import React, { Fragment } from 'react';
import BasePage from './BasePage';
import { connect } from 'react-redux';
import { setMenu, setModalContent } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Datepicker from '../components/Datepicker';
import Table from '../components/Table';
import FileUploader from '../components/FileUploader';
import $ from 'jquery';
import ArticleChart from '../components/ArticleChart'
import QRCode from 'react-qr-code'
import ReactToPrint from 'react-to-print'

class EditArticle extends BasePage {

	loadOnConstructor() {
		this.getArticle = this.getArticle.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.updateArticleCallback = this.updateArticleCallback.bind(this);
		this.newArticleCallback = this.newArticleCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.determineAction = this.determineAction.bind(this);
		this.altTab = this.altTab.bind(this);
		this.dateToString = this.dateToString.bind(this);
		this.openBookingCard = this.openBookingCard.bind(this);
		this.renderEditBooking = this.renderEditBooking.bind(this);
		this.changeScheduleCallback = this.changeScheduleCallback.bind(this);
		this.createNewBooking = this.createNewBooking.bind(this);

		this.downloadFile = this.downloadFile.bind(this);
		this.downloadFileCallback = this.downloadFileCallback.bind(this);
		this.formatDateToUserString = this.formatDateToUserString.bind(this);
		this.showAddFileWindow = this.showAddFileWindow.bind(this);
		this.sendUploadFile = this.sendUploadFile.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
		this.deleteFileConfirmed = this.deleteFileConfirmed.bind(this);
		this.deleteFileCallback = this.deleteFileCallback.bind(this);
		this.addQRCode = this.addQRCode.bind(this);
		this.showQRCodeWindow = this.showQRCodeWindow.bind(this);

		this.uploadFile = React.createRef();

		this.determineAction();
	}

	dateToString(dateObject, returnObject){
		const multiplier = returnObject?1:-1
		const hoursFromTimezoneOffset = (dateObject.getTimezoneOffset() * multiplier) / 60;
        let dateToString = new Date(dateObject.getTime());
        dateToString.setHours(dateObject.getHours() + hoursFromTimezoneOffset);

		return returnObject?dateToString:dateToString.toISOString()
	}

	determineAction() {
		const { article_id } = this.getUrlParams();
		if (article_id !== undefined) {
			this.state = { action: 'modify', article_id: article_id };
			this.getArticle(article_id);
		} else {
			this.state = { action: 'new', isSaving: false };
			this.getArticle();
		}

	}

	getArticle(articleId) {
		const api = this.getApi();
		api.getEditArticleInterface(articleId, (response) => {

			if (response.hasOwnProperty('auth') && response.auth === false) {
				this.navigateTo('/login');
				return;
			}

			for (let prop in response.article) {
				if (response.article[prop] === 'null') response.article[prop] = '';
			}

			let reports = {data: [], labels: []}

			 const economicData = response.economicData?.map(ed => {
						ed.creation_date = this.parseDateToString(ed.creation_date)
						return ed
			})??[]

			let chartData = {evolution: [], price: response.article?.buy_price??0, labels: []}
			let sum = 0;
			chartData.evolution.push(sum)
			response.economicData?.forEach(ed => {
				sum += parseFloat(ed.base_price)
				//data={{evolution: [0,100,200,600,850,1200], price: 800}} labels={['a', 'b', 'c', 'd', 'e', 'f']}
				chartData.evolution.push(sum)
				chartData.labels.push(ed.code)
			})

			this.setState(prevState => {
				return {
					...prevState,
					article: response.article,
					articleTypes: response.articleTypes,
					i18n: response.i18n,
					files: response.files || [],
					economicData,
					extra_data: response.extra_data?response.extra_data.map(ed => {
						ed.base_price = this.roundAndEuro(ed.base_price)
						ed.tax_price = this.roundAndEuro(ed.tax_price)
						ed.line_total_price = this.roundAndEuro(ed.line_total_price)
						return ed
					}):[],
					chartData,
					reports
				}
			});

		});
	}

	roundAndEuro(price){
		return (Math.round(price * 100) / 100)+'€' 
	}

	cancelButton() {
		this.goBack();
	}

	saveButton() {

		let failedValidators = {};
		if ($('#name').val() === '') {
			failedValidators.name = this.getTrad('fillNameField');
		}

		if ($('#code').val() === '') {
			failedValidators.code = this.getTrad('fillCodeField');
		}

		if ($('#status').val() === '' || $('#status').val() === '0') {
			failedValidators.status = this.getTrad('fillStatusField');
		}

		if ($('#articleType').val() === '' || $('#articleType').val() === '0') {
			failedValidators.articleType = this.getTrad('fillArticleTypeField');
		}

		if (Object.keys(failedValidators).length !== 0) {
			let message = [];
			for (let m in failedValidators) {
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: this.getTrad('fillAllMandatoryFields'),
				body: message,
				buttons: [
					{ shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}

		this.setState({ isSaving: true })
		const api = this.getApi();

		if (this.state.action === 'modify') {
			let updatedArticle = JSON.parse(JSON.stringify(this.state.article))
			updatedArticle.bookings = JSON.stringify(updatedArticle.bookings)
			api.updateArticle(updatedArticle, this.updateArticleCallback);
		} else {
			api.newArticle(this.state.article, this.newArticleCallback);
		}
	}

	updateArticleCallback(response) {
		this.setState({ isSaving: false })
		if (response.status === 'OK') {
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad('articleModifiedSuccessfully')],
				buttons: [
					{ shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack }
				]
			});

			$("#exampleModal").modal('toggle');
		} else {
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{ shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack }
				]
			});
			$("#exampleModal").modal('toggle');
		}
	}

	newArticleCallback(response) {
		this.setState({ isSaving: false })
		if (response.status !== 'OK') {

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{ shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');

		} else {
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad('articleCreatedSuccessfully')],
				buttons: [
					{ shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack }
				]
			});
			$("#exampleModal").modal('toggle');
		}
	}

	handleChange(event, target) {
		let articleMod = { ...this.state.article };

		if(target){
			this.state.bookingSelected[target.name] = this.dateToString(event)
		}else if(['booking_status'].indexOf(event.target.name) !== -1){
			
			this.state.bookingSelected[event.target.name] = parseFloat(event.target.value)

		}else if (event.target.name === 'articleType') {
			articleMod.article_type = event.target.value;
		}else if(event.target.name === 'buy_price' || event.target.name === 'sell_price'){
		    articleMod[event.target.name] = parseFloat(event.target.value.replace(/,/g,'.'));	
		}else {
			articleMod[event.target.name] = event.target.value;
		}

		this.setState(prevState => {
			return {
				...prevState,
				article: articleMod
			}
		});
	}

	altTab(tabId){
		const tabs = ['principal', 'reservas', 'ficheros', 'informe'];
	
		for (let tab in tabs){
			$('#'+tabs[tab]).css("display", "none");
			$('#'+tabs[tab]+"Tab").removeClass("active");
		}
	
		$('#'+tabId).css("display", "block");
		$('#'+tabId+"Tab").addClass("active");
		//aria-current="page"
	}

	prettifyDate(strDate){
		return strDate.substring(8,10)+'/'+
				strDate.substring(5,7)+'/'+
				strDate.substring(0,4)+' '+
				strDate.substring(11,13)+':'+
				strDate.substring(14,16)
	}

	showArticleState(bookings){

		let textStatus = this.getTrad("availableStatus")
		let cssStatus = 'success'
		let sold = false

		if(bookings && bookings.length>0)
		bookings.filter((booking) => {
			const now = this.dateToString(new Date())

			return ((booking.start_date <= now && booking.end_date > now) || booking.end_date === undefined 
				|| parseFloat(booking.booking_status) === 5)
		}).forEach(book => {
			if(book.booking_status === undefined) book.booking_status = book.status

			if(!sold){
				switch(parseFloat(book.booking_status)){
					case 1: textStatus = this.getTrad("availableStatus");break;
					case 2: textStatus = this.getTrad("occupedStatus");cssStatus = 'primary';break;
					case 3: textStatus = this.getTrad("repairingStatus");cssStatus = 'secondary';break;
					case 4: textStatus = this.getTrad("rentedStatus");cssStatus = 'primary';break;
					case 5: 
						textStatus = this.getTrad("soldStatus");cssStatus = 'secondary'
						sold = true
						break;
					default: textStatus = `Error con el estado del artículo ${book.booking_status}`; break;
				}
			}
		})

		return <h3 className={`badge ml-3 badge-${cssStatus} ml-3 font-weight-bold`}>{textStatus}</h3>
	}

	openBookingCard(arrayPosition){
		const booking = this.state.article?.bookings[arrayPosition];
		const bookingSelected = JSON.parse(JSON.stringify(booking))

		this.setState(prevState => {
			return {
				...prevState,
				bookingSelected: bookingSelected,
				bookingSelectedPosition: arrayPosition
			}
		},
		this.openBookingInfo);
	
	}
	
	openBookingInfo(){
		$("#editBooking").modal('toggle');
	}

	renderEditBooking(){
		const booking = this.state.bookingSelected
		return (<div className="row">
			<div className="col-12">
				<form>
					<div className="form-group">
						<label htmlFor="start_date">{this.getTrad("startDate")}&nbsp;</label>
						<Datepicker id="start_date" name="start_date" onChange={this.handleChange} showTimeSelect={true}
						selected={booking?this.dateToString(new Date(booking.start_date),true):new Date()}  />
					</div>
					{booking?.booking_status !== 5 &&
					<div className="form-group">
						<label htmlFor="end_date">{this.getTrad("endDate")}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
						<Datepicker id="end_date" name="end_date" onChange={this.handleChange} showTimeSelect={true}
						selected={booking?this.dateToString(new Date(booking.end_date),true):new Date()}  />
					</div>}
					<div className="form-group">
						<label htmlFor="booking_status">{this.getTrad("status")}</label>
						<select className="form-control" id="booking_status" name="booking_status"
						defaultValue={booking?booking.booking_status:''} onChange={this.handleChange}>
							<option value="1" selected={booking?.booking_status === 1?true:undefined}>
								{this.getTrad("availableStatus")}
							</option>
							<option value="2" selected={booking?.booking_status === 2?true:undefined}>
								{this.getTrad("occupedStatus")}
							</option>
							<option value="3" selected={booking?.booking_status === 3?true:undefined}>
								{this.getTrad("repairingStatus")}
							</option>
							<option value="4" selected={booking?.booking_status === 4?true:undefined}>
								{this.getTrad("rentedStatus")}
							</option>
							<option value="5" selected={booking?.booking_status === 5?true:undefined}>
								{this.getTrad("soldStatus")}
							</option>
						</select>
					</div>
				</form>
			</div>
		</div>)
	}

	changeScheduleCallback(){
		let newArticle = JSON.parse(JSON.stringify(this.state.article))
		newArticle.bookings[this.state.bookingSelectedPosition] = this.state.bookingSelected
		this.setState(prevState => {
			return {
				...prevState,
				bookingSelected: undefined,
				bookingSelectedPosition: undefined,
				article: newArticle
			}
		})

		$("#editBooking").modal('toggle');
	}

	createNewBooking(){

	}

	downloadFile(fileId){
		const api = this.getApi();
	
		this.setState(prevState => {
			return {
				...prevState,
					downloadFile: this.state.files.filter(file => file._id === fileId).pop()
			}
		},api.downloadFile(fileId, this.downloadFileCallback));
	}

	downloadFileCallback(response){

		const newBlob = new Blob([response], { type: 'application/octet-stream' });

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(newBlob);
				} else {
					// For other browsers: create a link pointing to the ObjectURL containing the blob.
					const objUrl = window.URL.createObjectURL(newBlob);

					let link = document.createElement('a');
					link.href = objUrl;
					link.download = this.state.downloadFile.name;
					link.click();

					// For Firefox it is necessary to delay revoking the ObjectURL.
					setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}

		this.setState(prevState => {
			return {
				...prevState,
				downloadFile: undefined
			}
		});
	}

	formatDateToUserString(dateString){
		return dateString.substring(8,10)+'/'+dateString.substring(5,7)+'/'+dateString.substring(0,4)+' '+
			dateString.substring(11,13)+':'+dateString.substring(14,16);
	}

	showAddFileWindow(){
		this.props.setModalContent({
			title: this.getTrad('addFile'),
			body: [
				(<FileUploader ref={this.uploadFile}  onSendFile={this.sendUploadFile} aditionalFields={[{name: 'article', value: this.state.article_id }]} />)
			],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', callback:() => {this.uploadFile.current.sendForm()}, close: true},
				{shown: 'Cancelar', close: true}
			]
		});
	
		$("#exampleModal").modal('toggle');
	}

	sendUploadFile(response){
		if(response.status === 'OK'){
	
			let currFiles = JSON.parse(JSON.stringify(this.state.files)); 
			currFiles.unshift(response.file);
	
			this.setState(prevState => {
			return {
				...prevState,
				files: currFiles
			}
			});
		}
		
	}

	deleteFile(fileId){
		this.props.setModalContent({
			title: this.getTrad('deleteFile'),
			body: [this.getTrad('AreYouSureYouWantToDeleteFile')],
			buttons: [
			{shown: 'Aceptar', behaviour: 'main', close: true, callback: () => {this.deleteFileConfirmed(fileId)}},
			{shown: 'Cancelar', close: true}
			]
		});
	
		$("#exampleModal").modal('toggle');
	}
	
	deleteFileConfirmed(fileId){
		const api = this.getApi();
		this.setState(prevState => {
			return {
				...prevState,
					fileToRemove: fileId
			}
		},api.deleteFile(fileId, this.deleteFileCallback));
	}
	
	deleteFileCallback(response){
		let currFiles = JSON.parse(JSON.stringify(this.state.files)); 
	
		if(response.status === 'OK'){
			this.setState(prevState => {
				return {
					...prevState,
						files: currFiles.filter(file => {
						return file._id !== this.state.fileToRemove
					})
				}
			});
		}
	}

	parseDateToString(stringDate) {
		const date = new Date(stringDate)

		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return ("0" + dateToString.getUTCDate()).slice(-2)+ "/"+
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "/" +
			dateToString.getUTCFullYear()
			
	}

	addQRCode(){
		const { article_id } = this.getUrlParams();
		if (article_id !== undefined) return true

		return false
	}

	showQRCodeWindow(){

		this.props.setModalContent({
			title: this.getTrad('Código QR'),
			body: [
				<div>
					<div ref={el => (this.componentRef = el)} style={{ height: "auto", margin: "30px auto", maxWidth: 256, width: "100%" }}>
						<QRCode size={256} viewBox={`0 0 256 256`}
						style={{ height: "auto", maxWidth: "100%", width: "100%" }}
						value={window.location.href} /> 
						<div className="mt-4">
							{this.state.article?`${this.state.article.name}  - Código: ${this.state.article.code}`:''}
						</div>
					</div>

					<div className="row mt-3 text-center">
						<div className="col-3 text-center" style={{margin:"0px auto"}}>
							<ReactToPrint
								onBeforePrint={() => {document.title = "Nombre del artículo - CRM Accedan"}}
								onAfterPrint={() => {document.title = "Nombre del artículo - CRM Accedan"}}
								trigger={() => {
									return (
										<button type="button" className="btn btn-primary">Imprimir</button>
										)
								}}
								content={() => this.componentRef}
							/>
						</div>
					</div>
				</div>
			],
			buttons: [
				{ shown: 'Cancelar', behaviour: 'close', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	render() {
		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('articleEdition')}</h3>

				<ul className="nav nav-tabs">
					<li className="nav-item">
						<a id="principalTab" className="nav-link active" aria-current="page" href="dummie" 
							onClick={(e) => { e.preventDefault(); this.altTab('principal') }}>
							Principal
						</a>
					</li>
					<li className="nav-item">
						<a id="reservasTab" className="nav-link" href="dummie" 
							onClick={(e) => { e.preventDefault(); this.altTab('reservas')}}>
							Reservas
						</a>
					</li>
					<li className="nav-item">
						<a id="ficherosTab" className="nav-link" href="dummie" 
							onClick={(e) => { e.preventDefault(); this.altTab('ficheros')}}>
							Ficheros
						</a>
					</li>
					<li className="nav-item">
						<a id="informeTab" className="nav-link" href="dummie" 
							onClick={(e) => { e.preventDefault(); this.altTab('informe')}}>
							Informe
						</a>
					</li>
				</ul>

				{/*Comienzo tab Principal*/}
				<div className="row mt-4" id="principal" style={{ display: 'block' }}>
					<div className="col-12">
						<form>
							<div className="form-group">
								<label htmlFor="name">Nombre</label>
								<input type="text" className="form-control" id="name" name="name"
									defaultValue={this.state.article ? this.state.article.name : ''} onBlur={this.handleChange} />
							</div>
							<div className="form-group">
								<label htmlFor="buy_price">Precio de compra</label>
								<input type="text" className="form-control" id="buy_price" name="buy_price"
									defaultValue={this.state.article ? this.state.article.buy_price : ''} onBlur={this.handleChange} />
							</div>
							<div className="form-group">
								<label htmlFor="sell_price">Precio de venta</label>
								<input type="text" className="form-control" id="sell_price" name="sell_price"
									defaultValue={this.state.article ? this.state.article.sell_price : ''} onBlur={this.handleChange} />
							</div>
							<div className="form-group">
								<label htmlFor="code">{this.getTrad("code")}</label>
								<input type="text" className="form-control" id="code" name="code"
									defaultValue={this.state.article ? this.state.article.code : ''} onBlur={this.handleChange} />
							</div>
							<div className="form-group">
								<label htmlFor="description">{this.getTrad("description")}</label>
								<textarea type="text" className="form-control" id="description"
									name="description" defaultValue={this.state.article ? this.state.article.description : ''}
									style={{ height: '80px' }} onBlur={this.handleChange} ></textarea>
							</div>

							<div className="form-group">
								<label htmlFor="status">{this.getTrad("status")}</label>
								{this.showArticleState(this.state.article?.bookings)}
							</div>

							<div className="form-group">
								<label htmlFor="articleType">{this.getTrad("articleType")}</label>
								<select className="form-control" id="articleType" name="articleType"
									value={this.state.article ? this.state.article.article_type : undefined} 
									defaultValue={this.state.article ? this.state.article.article_type : undefined} onChange={this.handleChange}>
									<option value='0'>{this.getTrad("selectAnOption")}</option>
									{this.state.articleTypes? this.state.articleTypes.map((at,idx) => {
										return <option key={'article_type_'+at._id} defaultValue={at._id} value={at._id}>{at.name}</option>
									}) 
									:<option value='0'>{this.getTrad("NoArticleTypesAvailable")}</option>}
									
								</select>
							</div>
							{this.addQRCode() && 
							<div onClick={this.showQRCodeWindow} 
							style={{ height: "auto", margin: "0 auto", maxWidth: 128, width: "100%" }}>
								<QRCode
								size={256}
								style={{ height: "auto", maxWidth: "100%", width: "100%" }}
								value={window.location.href}
								viewBox={`0 0 256 256`}
								/>
							</div>}
						</form>
					</div>
				</div>
				{/*Final tab Principal*/}

				{/* Comienzo tab Reservas */}
				<div className="row mt-4" id="reservas" style={{ display: 'none' }}>
					{/*}
					<div className="row">
						<div className="col-12 mb-3 ml-3">
							<button type="button" className="btn btn-primary" onClick={this.createNewBooking}>Crear nueva reserva</button>
						</div>
					</div>
					{*/}
					<div className="col-12">
						<form>
							{this.state.article && this.state.article.bookings && this.state.article.bookings.map((booking, idx) => {

								if(booking.status !== undefined) booking.booking_status = booking.status
								let textStatus

								switch(booking.booking_status){
									case 1: textStatus = this.getTrad("availableStatus"); break;
									case 2: textStatus = this.getTrad("occupedStatus"); break;
									case 3: textStatus = this.getTrad("repairingStatus"); break;
									case 4: textStatus = this.getTrad("rentedStatus"); break;
									case 5: textStatus = this.getTrad("soldStatus"); break;
									default: textStatus = ' '
								}

								return <Fragment key={"reservas_"+idx}>
									<div className={"card w-100 mb-2 border-secondary"} onClick={() => this.openBookingCard(idx)} style={this.cursorPointer}>
										<div className="card-body">
											<h5 className="card-title">
												Estado
												<span className={"badge ml-3 badge-secondary"}>{textStatus}</span>
											</h5>
											<h6 className="card-subtitle mb-2 text-muted">Inicio: {this.prettifyDate(booking.start_date)}</h6>
											{parseFloat(booking.booking_status) !== 5 && (<h6 className="card-subtitle mb-2 text-muted">Final: {this.prettifyDate(booking.end_date)}</h6>) }
											<p>Cliente: {booking.client?booking.client.name + ' '+booking.client.lastname:'Sin cliente'}</p>
										</div>
									</div>
								</Fragment>
							})}
						</form>
					</div>
				</div>
				{/* Final tab reservas */}

				{/*Comienzo tab ficheros*/}
				<div className="row mt-4 mb-3" id="ficheros" style={{display:'none'}}>
					<div className="row">
						<div className="col-12">

							<button type="button" className="btn btn-primary mb-2" onClick={this.showAddFileWindow}>Nuevo fichero</button>

					{this.state.files && this.state.files.length>0?this.state.files.map((file,idx) => {
							return (<div className="card w-100 mb-2 border-secondary" key={'file_'+file._id}> 
								<div className="card-body">
									<h5 className="card-title">
										{file.name}
										<span onClick={() => {this.downloadFile(file._id)}} className={"badge ml-3 badge-primary"} style={{cursor:'pointer'}}>Descargar</span>
										<span onClick={() => {this.deleteFile(file._id)}} className={"badge ml-3 badge-secondary"} style={{cursor:'pointer'}}>Eliminar</span>
									</h5>
									<h6 className="card-subtitle mb-2 text-muted">{this.formatDateToUserString(file.creation_date)}</h6>
									<p className="card-text">Usuario: {file.created_by_user.name+' '+file.created_by_user.lastname} </p>
									<p className="card-text ">{file.comments}</p>
								</div>
							</div>);
						}):(<div className="row mt-2"><div className="col-12 text-center">No hay ficheros para mostrar</div></div>)}

						</div>
					</div>
				</div>
				{/*Final tab ficheros*/}

				{/* Comienzo tab Informe */}
				
				<div className="row mt-4" id="informe" style={{ display: 'none' }}>
					<div className="row">
						<div className="col-6">
							<Table 
								config = {{
									items: this.state.economicData?this.state.economicData:[],
									extra_data: this.state.extra_data?this.state.extra_data:[],
									i18n: this.state.i18n !== undefined? this.state.i18n:[],
									mapping: [
										{original: 'code', shown: 'Factura', visible: true},
										{original: 'creation_date', shown: 'Creación', visible: true},
										{original: 'operation', shown: 'Tipo operación', visible: true, display: 'extra_data',
										extra_data: {match: '_id', value: 'operation'}},
										{
											original: 'base_price', shown: 'Base imponible', visible: true, display: 'extra_data', textRight: 1,
											extra_data: {match: '_id', value: 'base_price'}
										},
										{original: '_id', shown: '_id', visible: false}
									]
								}}
							/>
						</div>
						<div className="col-6">
							<ArticleChart data={{evolution: this.state.chartData?.evolution, price: this.state.chartData?.price || 0}} labels={[''].concat(this.state.chartData?.labels)} />
						</div>
					</div>
					
				</div>
				
				{/* Final tab Informe */}

				<div className="row">
					<div className="col-12">
						<div className="d-flex justify-content-between align-items-center mb-2">
							<button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>{this.state.isSaving ? 'Guardando...' : 'Guardar'}</button>
							<button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
						</div>
					</div>
				</div>

				<div className="modal fade" id="editBooking" tabIndex="-1" role="dialog" aria-labelledby="editBookingTitleLabel" aria-hidden="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="editBookingTitleLabel">
									{this.getTrad('bookingInfo')}
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								{this.renderEditBooking()}
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-primary" data-dismiss="modal"
									onClick={() => {
										const api = this.getApi();
										let bookingToApi = JSON.parse(JSON.stringify(this.state.bookingSelected));
										//TODO: enviar solo el id y los bookings
										let articleToApi = JSON.parse(JSON.stringify(this.state.article))
										articleToApi.bookings[this.state.bookingSelectedPosition] = bookingToApi
										articleToApi.bookings = JSON.stringify(articleToApi.bookings);

										api.updateArticle(articleToApi, this.changeScheduleCallback);
										
									}}>
									{this.getTrad("Aceptar")}
								</button>
								<button type="button" className="btn btn-secondary" data-dismiss="modal"
									onClick={() => {
										$("#editBooking").modal('toggle');
										
									}}>
									{this.getTrad("Cancelar")}
								</button>

							</div>
						</div>
					</div>
				</div>

				<Modal />
			</div>
		);
	}

	cursorPointer = {
		cursor: 'pointer'
	}
}

const mapStateToProps = state => {
	return {
		menu: state.menu,
		clients: state.clients
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setMenu(menu) {
			dispatch(setMenu(menu));
		},
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(EditArticle)
